import React from "react";
import styles from "./STHeroCommon.module.css";
import clsx from "clsx";

const parseDraftOrRaw = (content) => {
  if (!content) return "";
  if (typeof content === "object") {
    if (content.blocks && Array.isArray(content.blocks)) {
      return content.blocks.map((b) => b.text).filter(Boolean).join("\n");
    }
  }
  if (typeof content === "string") {
    try {
      const parsed = JSON.parse(content);
      if (parsed?.blocks && Array.isArray(parsed.blocks)) {
        return parsed.blocks.map((b) => b.text).filter(Boolean).join("\n");
      }
    } catch (e) {
      // raw string
    }
  }
  return String(content);
};

export const STHeroCommon = ({ title, description, extraContent }) => {
  const parsedTitle = parseDraftOrRaw(title);
  const parsedDescription = parseDraftOrRaw(description);

  return (
    <section
      className={clsx(
        styles.heroCommon,
        "d-flex justify-content-center align-items-center bg-black position-relative overflow-hidden",
      )}
    >
      <div className="container">
        <div className="d-flex justify-content-center align-items-center">
          <div className={clsx(styles.heroCommonContent, "text-center")}>
            <h1 className={"fw-normal text-white mb-0"}>{parsedTitle || title}</h1>
            {(parsedDescription || description) && (
              <p
                className={clsx(
                  styles.heroCommonDescription,
                  "paragraph-text mb-0 space-sm-mt text-clr-white-55",
                )}
              >
                {parsedDescription || description}
              </p>
            )}
            {extraContent}
          </div>
        </div>
      </div>
    </section>
  );
};

